module.exports = __webpack_public_path__ + "static/media/up-icon.ec7b189f.svg";